<template>
  <div id="app">
    <!-- <div :style="{ minHeight: 'calc(100vh - ' + dheight + 'px)' }"> -->
    <router-view />
    <!-- </div> -->
    <Concat></Concat>
    <Footer ref="footer" v-show="getIsShowHeaderAndFooter"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";

import Concat from "@/components/Concat";

export default {
  components: { Footer, Concat },
  computed: {
    getIsShowHeaderAndFooter() {
      return this.$store.getters.isShowHeaderAndFooter;
    },
  },
  data() {
    return {
      dheight: 200,
      isShowHeaderAndFooter: true,
    };
  },
  mounted() {
    // this.getHeight();
    // this.$store.dispatch("global/systemSetting");
  },
  methods: {
    getHeight() {
      this.$nextTick(() => {
        const header = this.$refs.header.$el.offsetHeight;
        const footer = this.$refs.footer.$el.offsetHeight;
        this.dheight = header + footer;
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  background: #f4f4f4;
}

/*滚动条宽度和颜色设置*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #efefef;
}

/*滚动条轨道的颜色*/
::-webkit-scrollbar-track {
  background-color: #efefef;
}

/*滚动条的小圆球颜色*/
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #616161;
}
</style>
